module.exports = __webpack_public_path__ + "b7beee9d079a587236383ba89d3e190e.png";